import { Bar } from 'react-chartjs-2';
import { ICurrentApplicationData } from '../ApplicationsBarChart';
import { useTranslation } from 'react-i18next';
import { currentOptions } from '../applicationChartOptions';

interface ICurrentApplicationBarProps {
  currentData: ICurrentApplicationData[];
}

export const CurrentApplicationBar = ({
  currentData,
}: ICurrentApplicationBarProps) => {
  const { t } = useTranslation();

  const sortedCurrentData = currentData.sort((a, b) => {
    const aTotal = a.data.all_count;
    const bTotal = b.data.all_count;
    return bTotal - aTotal;
  });

  const barWidth = sortedCurrentData.length === 1 ? 0.2 : 0.7;

  const currentDataBar = {
    labels: sortedCurrentData.map(item =>
      item.label.substring(item.label.indexOf(' ') + 1)
    ),
    datasets: [
      {
        label: t('cancelled'),
        data: sortedCurrentData.map(item => item.data.statistic.expired),
        backgroundColor: 'rgba(255, 188, 188, 1)',
        hoverBackgroundColor: 'rgba(255, 99, 132, 1)',
        borderRadius: 8,
        barPercentage: barWidth,
      },
      {
        label: t('created_by'),
        data: sortedCurrentData.map(item => item.data.statistic.created),
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        hoverBackgroundColor: 'rgba(54, 162, 235, 1)',
        borderRadius: 8,
        barPercentage: barWidth,
      },

      {
        label: t('completed'),
        data: sortedCurrentData.map(item => item.data.statistic.completed),
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        hoverBackgroundColor: 'rgba(75, 192, 192, 1)',
        borderRadius: 8,
        barPercentage: barWidth,
      },
    ],
  };

  const currentApplicationOptions = {
    ...currentOptions(currentData),
  };

  return <Bar data={currentDataBar} options={currentApplicationOptions} />;
};
